import {
    Edit,
    required,
    TextInput,
    BooleanInput,
    Link,
    SimpleForm,
    TabbedShowLayout,
    Tab,
    useNotify,
    useDataProvider,
    FunctionField,
    useRefresh, NumberInput, minValue
} from "react-admin";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useParams} from "react-router-dom";
import EventHistoryLocalization from "./eventHistoryLocalization";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import {Calendar} from "react-multi-date-picker";
import {convertedDate, convertedDateWithTime, convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

export const EditEventHistory = () => {
    const {id} = useParams();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const dispatch = useDispatch();

    const onDateChange = (e, period) => {
        if (e && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            formData[period] = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`;
        }
    }

    const initialRef = useRef(true);
    const [formData] = useState({
        name: '',
        description: '',
        start_date: '',
        end_date: '',
        order: 0,
        published: false
    });

    useEffect(() => {
        if (!initialRef.current) {
            return;
        }
        initialRef.current = false;
    }, []);

    const editCreate = () => {
        let startDate = formData.start_date || document.getElementById('start_date').value;
        let endDate = formData.end_date || document.getElementById('end_date').value;

        if(!startDate.length) {
            notify('Start date is required', 'warning');
            return ;
        }

        if(!endDate.length) {
            notify('End date is required', 'warning');
            return ;
        }

        if(startDate.length && endDate.length) {
            let startD = new Date(startDate);
            let endD = new Date(endDate);
            if (startD.getTime() > endD.getTime()) {
                notify("Start date can't be earlier than end date", 'warning');
                return ;
            }
        }

        if (!formData.name.length || formData.order <= 0) {
            if (!formData.name.length) {
                document.querySelector('.name').classList.add('error');
            }

            if (formData.order <= 0) {
                document.querySelector('.order').classList.add('error');
            }

            return;
        }

        dispatch(setLoadStatus(true));

        dataProvider.update(`event-histories/general`, {id: `${id}`, data: {
                name: formData.name,
                start_date: startDate,
                end_date: endDate,
                description: formData.description,
                order: formData.order,
                published: formData.published ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False
            }}).then(() => {
            dispatch(setLoadStatus(false));
            notify(`Event update`);
            refresh(true);
        }).catch((err) => {
            notify(err.message, {type: 'error'});
            dispatch(setLoadStatus(false));
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                    <Link to="/event-histories/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={editCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    const orderChange = (e) => {
        const val = +e.target.value;
        if (val <= 0) {
            document.querySelector('.order').classList.add('error');
            return;
        }
        if (document.querySelector('.order').classList.contains('error')) {
            document.querySelector('.order').classList.remove('error');
        }
        formData.order = val;
    }

    return (
        <>
            <h2 className="dailyTitle">Edit Event</h2>
            <Edit title="Event">
                <TabbedShowLayout className="tabbedForm">
                    <Tab label="General">
                        <SimpleForm toolbar={<></>}>
                            <div className="tabbedFormWrap">
                                <FunctionField label="" render={(record) => {
                                    formData.name = record.name;
                                    return <>
                                        <TextInput className="formFields name" label="Name" name="name"
                                                   source="formData.name" fullWidth id="name" validate={required()}
                                                   onChange={(e) => {
                                                       nameChange(e)
                                                   }} multiline/>
                                        <p className="required-text">Required</p>
                                    </>;
                                }}/>
                                <FunctionField label="" render={(record) => {
                                    formData.description = record.description;
                                    return <TextInput className="formFields" label="Description" name="description" source="formData.description" id="description" multiline fullWidth onChange={(e) => {
                                        formData.description = e.target.value
                                    }} />;
                                }}/>
                                <FunctionField label="" render={(record) => {
                                    formData.order = record.order;
                                    return <>
                                        <NumberInput label="Order" name="order" source="order" min={1} className="numberInput order" fullWidth id="order" validate={[required(), minValue(1)]} onChange={(e) => {orderChange(e)}}/>
                                        <p className="required-text">Must be at least 1</p>
                                    </>;
                                }}/>
                                <FunctionField label="" render={(record) => {
                                    formData.published = record.published;
                                    return <BooleanInput label="Visible"
                                                         name="published"
                                                         source="published"
                                                         className="booleanInput"
                                                         format={(value) => (value ? EBooleanStatuses.True : EBooleanStatuses.False)}
                                                         parse={(value) => (value ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False)}
                                                         onChange={(e) => {
                                                             formData.published = e.target.checked
                                                         }}/>;
                                }}/>
                                <span className="showDateLabel">Start Date</span>
                                <FunctionField source="start_date" render={(record) => {
                                    return (
                                        <>
                                            <Calendar
                                                value={record.start_date ? convertedDateWithTimeGMT(record.start_date, '') : null}
                                                onPropsChange={(e) => {
                                                    onDateChange(e, 'start_date')
                                                }}
                                                format="YYYY-MM-DD HH:mm"
                                                plugins={[<TimePicker position="bottom" hideSeconds />]}
                                                minDate="2000/01/01"
                                                maxDate="3000/12/31"
                                            />
                                            <input type="hidden" id="start_date"
                                                   value={record.start_date && !formData.start_date ? convertedDateWithTimeGMT(record.start_date) : formData.start_date}/>
                                        </>
                                    );
                                }}/>
                                <span className="showDateLabel showDateLabelEnd">End Date</span>
                                <FunctionField source="end_date" render={(record) => {
                                    return (
                                        <>
                                            <Calendar
                                                value={record.end_date ? convertedDateWithTimeGMT(record.end_date, '') : null}
                                                onPropsChange={(e) => {
                                                    onDateChange(e, 'end_date')
                                                }}
                                                format="YYYY-MM-DD HH:mm"
                                                plugins={[<TimePicker position="bottom" hideSeconds />]}
                                                minDate="2000/01/01"
                                                maxDate="3000/12/31"
                                            />
                                            <input type="hidden" id="end_date"
                                                   value={record.end_date && !formData.end_date ? convertedDateWithTimeGMT(record.end_date) : formData.end_date}/>
                                        </>
                                    );
                                }}/>
                            </div>
                            <Save />
                        </SimpleForm>
                    </Tab>
                    <Tab label="EN" path="en">
                        <EventHistoryLocalization />
                    </Tab>
                    <Tab label="PT" path="pt">
                        <EventHistoryLocalization />
                    </Tab>
                    <Tab label="DE" path="de">
                        <EventHistoryLocalization />
                    </Tab>
                </TabbedShowLayout>
            </Edit>
        </>
    );
}